var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeviceImacStreamlineTabler(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.34375 6.75C5.34375 6.37704 5.49191 6.01935 5.75563 5.75563C6.01935 5.49191 6.37704 5.34375 6.75 5.34375H29.25C29.623 5.34375 29.9806 5.49191 30.2444 5.75563C30.5081 6.01935 30.6562 6.37704 30.6562 6.75V23.625C30.6562 23.998 30.5081 24.3556 30.2444 24.6194C29.9806 24.8831 29.623 25.0312 29.25 25.0312H6.75C6.37704 25.0312 6.01935 24.8831 5.75563 24.6194C5.49191 24.3556 5.34375 23.998 5.34375 23.625V6.75Z",
    stroke: "#246B72",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.34375 19.4062H30.6562",
    stroke: "#246B72",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 30.6562H23.625",
    stroke: "#246B72",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1875 25.0312L14.4844 30.6562",
    stroke: "#246B72",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8125 25.0312L21.5156 30.6562",
    stroke: "#246B72",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceImacStreamlineTabler);
export default __webpack_public_path__ + "static/media/Device-Imac--Streamline-Tabler.a6527baeaf12c4d379b3eb11f25dbf81.svg";
export { ForwardRef as ReactComponent };